import React from 'react';
import {Button, ClickAwayListener, Stack, Typography, useTheme} from '@mui/material';
import {useNavigate} from 'react-router-dom';

import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {MyPaymentsEnum} from 'presentation/constants';

import type {CoparticipationTooltipCardProps} from '../../types';
import {
	TooltipPopper,
	TooltipContainer,
	TooltipPaper,
	TooltipHeaderStack,
	TooltipCloseButton,
	TooltipArrow,
} from './styles';

const {coparticipationDetails, accessCoparticipation, access} =
	translations['pt-br'].privateFlow.myFinancial.openBills.detailsDrawer;

function CoparticipationTooltipCard({anchorEl, open, onClose}: CoparticipationTooltipCardProps) {
	const navigate = useNavigate();
	const {palette} = useTheme();

	const handleAccess = () => {
		onClose();
		navigate(MyPaymentsEnum.COPARTICIPATION);
	};

	return (
		<TooltipPopper open={open} anchorEl={anchorEl} placement="top">
			<ClickAwayListener onClickAway={onClose}>
				<TooltipContainer>
					<TooltipPaper elevation={3}>
						<TooltipHeaderStack
							direction="row"
							justifyContent="space-between"
							alignItems="flex-start">
							<Typography variant="subtitle2" fontWeight={600}>
								{coparticipationDetails}
							</Typography>
							<TooltipCloseButton size="small" onClick={onClose}>
								<Icon name="close-default" size={16} color={palette.text.secondary} />
							</TooltipCloseButton>
						</TooltipHeaderStack>
						<Typography variant="body2" color="text.secondary">
							{accessCoparticipation}
						</Typography>
						<Stack direction="row" justifyContent="flex-end" mt={1}>
							<Button variant="text" size="small" onClick={handleAccess}>
								{access}
							</Button>
						</Stack>
					</TooltipPaper>
					<TooltipArrow />
				</TooltipContainer>
			</ClickAwayListener>
		</TooltipPopper>
	);
}

export {CoparticipationTooltipCard};
